import { promptVars } from '../variables';
import { applicationTypeGeneratePrompt } from './applicationTypeGeneratePrompt';
export const applicationTypeVerifyPrompt = applicationTypeGeneratePrompt.ai(promptVars.type).human('Is the type correct? Return TRUE or FALSE');
//# sourceMappingURL=applicationTypeVerifyPrompt.js.map